import React from "react";
import './css/Consortium.css';
import { Link } from 'react-router-dom';

export const Consortium = (props) => {
  return (
    <div id="consortiumandteam">
      <div id="consortium" className="grid-section">
        <div className="grid-entity">
          <h3 className="section-description">
          This testbed is currently being maintained by the University of Surrey. Please contact us on <a>leoscopetestbed@surrey.ac.uk</a> for any questions.
          The testbed code is available on <a href='https://github.com/leoscope-testbed'> Github Repository </a> as open source. Thanks to all the contributors listed below:
          </h3>
          <h2 className="section-title">Developers and Maintainers</h2>
          <ul className="entity-list">
              <li className="team-item">Nishanth Sastry, University of Surrey</li>
              <li className="team-item">Mohamed Kassem, University of Surrey</li>
              <li className="team-item">Vinod Khandkar, University of Surrey</li>
              <li className="team-item">Abdullahi Abubakar, University of Surrey</li>
              <li className="team-item">Roger Zhang,  University of Surrey</li>
              <li className="team-item">Saeed Fadaei,  University of Surrey</li>
              <li className="team-item">James Cocker,  University of Surrey</li>
              <li className="team-item">Aravindh Raman, (While at) Telefonica</li>
	      <li className="team-item">Debopam Bhattacherjee, Microsoft Research (India)</li>
	      <li className="team-item">Aryan Taneja, Microsoft Research (India)</li>
              <li className="team-item">Shubham Tiwari, (While at) Microsoft Research (India)</li>
              <li className="team-item">Saksham Bhushan, (While at) Microsoft Research (India)</li>

          </ul>
        </div>
      </div>
        <div id="consortium" className="grid-section">
        <div className="grid-entity">
        <h6 className="section-description">
        Nodes for the testbed have been donated/contributed by:
      </h6>
          <h2 className="section-title">Node Contributors</h2>
          <ul className="entity-list">
              <li className="team-item">University of Surrey (London, Wrexham, and Nigeria)</li>
	      <li className="team-item">Edinburgh (Edinburgh Node)</li>
              <li className="team-item">Telefonica (Madrid Node)</li>
       	      <li className="team-item">University of Victoria</li>
	      <li className="team-item">Technical University of Munich</li>
              <li className="team-item">Osnabrück University</li>
	      <li className="team-item">Virginia Tech</li>
	  </ul>
        </div>
        </div>
    </div>
  );
};

